import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbRole } from '@/models/alodb/AloDbRole'
import { AloBaseArray } from '@/models/alo/AloBaseArray'


export default {  
  getRoles(): AxiosPromise<AlrContainer<AloBaseArray<AloDbRole>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/role', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbRole>>(JSON.parse(data),AloDbRole.createAloDbRoleArray)
      }]
    })
  },
  getRole(id:number):AxiosPromise<AlrContainer<AloDbRole>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/role/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbRole>(JSON.parse(data),AloDbRole.createAloDbRoleWithDetail)
      }]
    })
  },
  saveRole(role:AloDbRole):AxiosPromise<AlrContainer<AloDbRole>> {
    if(role.ROL_ID && role.ROL_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/role/${role.ROL_ID}`, 
        method: 'PUT',
        data: role,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbRole>(JSON.parse(data),AloDbRole.createAloDbRoleWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/role`, 
        method: 'POST',
        data: role,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbRole>(JSON.parse(data),AloDbRole.createAloDbRoleWithDetail)
        }]
      })    
    }    
  }
  
}